import React from "react";
import { useHistory } from "react-router-dom";

const NotAuthorized = () => {
  const history = useHistory();

  return (
    <div className="container vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center p-5 bg-white rounded-4 shadow-sm" style={{ maxWidth: '500px' }}>
        <div className="mb-4">
          <div className="d-inline-flex align-items-center justify-content-center bg-danger-light rounded-circle p-4 animate-bounce">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
        </div>
        <h1 className="h3 fw-bold text-dark mb-3">Access Denied</h1>
        <p className="text-muted mb-4">
          You are not authorized to visit this page. This area is restricted to specific user roles.
        </p>
        <div className="d-flex gap-2 justify-content-center mt-4">
          <button 
            className="btn btn-primary px-4" 
            onClick={() => history.push("/")}
          >
            <i className="fa fa-home me-2"></i> Homepage
          </button>
          <button 
            className="btn btn-outline-secondary px-4" 
            onClick={() => history.goBack()}
          >
            <i className="fa fa-arrow-left me-2"></i> Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;
